export const TwitterIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22.71" height="18.45" viewBox="0 0 22.71 18.45">
    <path
      fill="#fff"
      d="M22.7,2.19A9.51,9.51,0,0,1,20,2.92,4.59,4.59,0,0,0,22.07.35a9.19,9.19,0,0,1-2.95,1.12,4.66,4.66,0,0,0-8.06,3.19,4.79,4.79,0,0,0,.12,1.06A13.15,13.15,0,0,1,1.58.85,4.65,4.65,0,0,0,3,7.07,4.52,4.52,0,0,1,.91,6.5v0a4.68,4.68,0,0,0,3.73,4.58,5,5,0,0,1-1.22.15,4.3,4.3,0,0,1-.88-.08,4.68,4.68,0,0,0,4.34,3.24,9.25,9.25,0,0,1-5.77,2A6.89,6.89,0,0,1,0,16.36a13.11,13.11,0,0,0,7.14,2.09A13.15,13.15,0,0,0,20.39,5.39V5.2c0-.2,0-.4,0-.6a9.45,9.45,0,0,0,2.34-2.42"
    />
  </svg>
)
